module.exports = __webpack_public_path__ + "static/fakenet-6551a49f2e2f650bb84eb4eafb3f9785.png";